import { SUBSCRIPTION_TIERS } from "seneca-common/features/subscriptions/features/subscription-products/state";
import {
  capitaliseEachWord,
  formatDateToText,
  splitCamelCaseWord
} from "seneca-common/utils/functions/format";

interface GetRenewalTextArgs {
  isCancelled: boolean;
  isExpired: boolean;
  isManaged: boolean;
  tierName?: string;
  renewalDate?: string;
}
export function getRenewalText({
  isCancelled,
  isExpired,
  isManaged,
  renewalDate,
  tierName
}: GetRenewalTextArgs) {
  const renewalDateToStr = renewalDate && formatDateToText(renewalDate);
  const capitalisedTierName = getTierNameHeader(tierName);

  if (isCancelled || isExpired) {
    return `This ${capitalisedTierName} package has ${
      isExpired ? "expired" : "been cancelled"
    }.  Access ${isExpired ? "lost" : "will be lost"} on ${renewalDateToStr}.`;
  }

  return `This ${capitalisedTierName} package will ${
    isManaged ? "expire" : "renew"
  } on ${renewalDateToStr}.`;
}

export function getTierNameHeader(tierName?: string | null) {
  if (tierName === SUBSCRIPTION_TIERS.tutoring) {
    return "Instant Tutor Support";
  }

  if (tierName === SUBSCRIPTION_TIERS.aiAssistant) {
    return "Amelia AI Assistant";
  }

  return capitaliseEachWord(splitCamelCaseWord(tierName));
}
